export const siteInfo = {
  name: '逼特逼视频',
  tagline: '官方平台入口与内容指南',
  description: '逼特逼视频是当前热门视频内容平台，为您详细介绍核心功能、内容分类、使用技巧及常见问题解答，帮助用户快速上手，畅享优质视频体验。',
  keywords: '逼特逼视频,逼特逼视频官网,逼特逼视频下载,逼特逼视频内容,逼特逼视频使用教程,逼特逼视频最新版,逼特逼视频平台入口',
  url: 'https://www.bitbivideo.com',
  email: 'contact@bitbivideo.com',
  phone: '400-888-9999',
  address: '北京市朝阳区科技园区创新路168号',
  foundingYear: 2020,
  socialLinks: {
    weibo: 'https://weibo.com/bitbivideo',
    wechat: 'bitbivideo_official',
    qq: 'https://v.qq.com/bitbi',
  },
  stats: [
    { label: '月活用户', value: '2.8亿+' },
    { label: '日均播放', value: '15亿+' },
    { label: '内容创作者', value: '500万+' },
    { label: '覆盖国家', value: '150+' },
  ],
};